import React from 'react';
import { InvoiceForm } from './InvoiceForm';

const InvoiceCreatePage: React.FC = () => {
  return <InvoiceForm />;
};

export default InvoiceCreatePage;
